import aiServer from '@assets/images/solution/recommendation/mobile/aiServer.avif';
import co2 from '@assets/images/solution/recommendation/mobile/co2.avif';
import edgeRtls from '@assets/images/solution/recommendation/mobile/edgeRtls.avif';
import fisheye from '@assets/images/solution/recommendation/mobile/fisheye.avif';
import idCard from '@assets/images/solution/recommendation/mobile/idCard.avif';
import ipCamera from '@assets/images/solution/recommendation/mobile/ipCamera.avif';
import loraGateway from '@assets/images/solution/recommendation/mobile/loraGateway.avif';
import nvr from '@assets/images/solution/recommendation/mobile/nvr.avif';
import patientTag from '@assets/images/solution/recommendation/mobile/patientTag.avif';
import ptz from '@assets/images/solution/recommendation/mobile/ptz.avif';
import safeCradle from '@assets/images/solution/recommendation/mobile/safeCradle.avif';
import safeTag from '@assets/images/solution/recommendation/mobile/safeTag.avif';
import safetyBell from '@assets/images/solution/recommendation/mobile/safetyBell.avif';
import server from '@assets/images/solution/recommendation/mobile/server.avif';
import slimTag from '@assets/images/solution/recommendation/mobile/slimTag.avif';
import stickerTag from '@assets/images/solution/recommendation/mobile/stickerTag.avif';
import switchImg from '@assets/images/solution/recommendation/mobile/switch.avif';
import twintrackerUwb from '@assets/images/solution/recommendation/mobile/twintrackerUwb.avif';
import uwbTag from '@assets/images/solution/recommendation/mobile/uwbTag.avif';
import plutoconPro from '@assets/images/solution/recommendation/mobile/plutoconPro.avif';
import twintrackerBLE from '@assets/images/solution/recommendation/mobile/twintrackerBle.avif';

export default {
  ipCamera: {
    title: 'IP Camera',
    desc: 'IP Camera는 인터넷 프로토콜을 기반으로 영상 데이터를 네트워크를 통해 전송하는 디지털 CCTV로, 설치가 간편하고 원격 모니터링과 영상 저장이 가능해 보안, 안전, 운영 관리 등에 널리 사용되는 감시 카메라입니다.',
    img: ipCamera,
    link: '/camera/edge',
  },
  ptzCamera: {
    title: 'PTZ Camera',
    desc: 'PTZ 카메라는 Pan-Tilt-Zoom 기능을 갖춘 고성능 CCTV로, 좌우 회전(Pan), 상하 기울임(Tilt), 광학 줌(Zoom)을 원격으로 제어할 수 있어 넓은 영역을 한 대의 카메라로 효율적으로 모니터링할 수 있는 감시 장비입니다.',
    img: ptz,
    link: '/camera/edge',
  },
  fisheyeCamera: {
    title: 'Fisheye Camera',
    desc: 'Fisheye Camera는 180도 이상의 초광각 렌즈를 사용해 한 대로 넓은 공간 전체를 촬영할 수 있는 CCTV로, 왜곡을 감수하고도 사각지대 없는 전방위 모니터링이 가능한 것이 특징입니다.',
    img: fisheye,
    link: '/camera/edge',
  },
  co2: {
    title: 'CO₂ Detector',
    desc: '일산화탄소 측정기는 공기 중 CO 농도를 실시간으로 감지하여 위험 임계값 도달 시 경고음을 울리고 시각적으로 알림을 제공하며, 독립된 배터리 또는 전원 공급 방식으로 현장 안전 관리를 지원하는 필수 안전 장비입니다.',
    img: co2,
    link: '/iot/co2',
  },
  server: {
    title: 'ORBRO Server',
    desc: 'ORBRO Server는 RTLS, CCTV, 센서 등 다양한 현장 디바이스로부터 수집한 데이터를 통합 관리하고, 실시간 분석·보고·알림 기능을 제공하며, API 연동을 통해 기업 시스템과 매끄럽게 연결되는 핵심 중앙 서버 플랫폼입니다.',
    img: server,
    link: '/os/server',
  },
  aiServer: {
    title: 'ORBRO AI Server',
    desc: 'ORBRO AI Server는 현장에서 수집되는 영상과 감지 데이터를 실시간으로 분석해 이상 상황을 자동으로 감지하고, 네트워크 부담 없이 즉시 알림 및 보고 기능을 제공하는 지능형 엣지 AI 분석 서버입니다.',
    img: aiServer,
    link: '/camera/server',
  },
  nvr: {
    title: 'NVR',
    desc: 'NVR(Network Video Recorder)은 카메라로부터 전송된 영상을 네트워크를 통해 수신하고 저장·관리하는 장치로, 다수의 카메라 영상을 동시에 녹화하고 실시간 모니터링 및 검색 기능을 제공하는 디지털 영상 저장 솔루션입니다.',
    img: nvr,
    link: '/camera/server',
  },
  twintarckerUWB: {
    title: 'TwinTracker UWB',
    desc: 'TwinTracker UWB는 UWB 신호를 수신해 ±10cm 이내의 고정밀 위치를 계산하며, 다중 태그를 동시에 추적하고 복잡한 공간에서도 안정적인 실시간 위치 데이터를 제공하는 초광대역 기반 위치추적 리더입니다.',
    img: twintrackerUwb,
    link: '/rtls/uwb',
  },
  twintarckerBLE: {
    title: 'TwinTracker BLE',
    desc: 'TwinTracker BLE는 저전력 블루투스 신호를 감지해 태그의 위치를 영역 단위로 파악하며, 설치와 운영이 간편해 다수의 자산이나 인원의 위치 분포를 효율적으로 관리할 수 있는 실내용 위치추적 전용 리더입니다.',
    img: twintrackerBLE,
    link: '/rtls/uwb',
  },
  uwbTag: {
    title: 'UWB Tag',
    desc: 'UWB 태그는 사람이나 장비에 부착해 ±10cm 이내의 오차로 위치를 실시간 추적할 수 있으며, 충격과 방수에 강하고 저전력 설계로 장시간 사용이 가능한 고정밀 위치추적 장치입니다.',
    img: uwbTag,
    link: '/rtls/uwb',
  },
  stickerTag: {
    title: 'Sticker Tag',
    desc: 'Sticker Tag는 자산에 쉽게 부착할 수 있는 초소형 태그로, 실시간 위치 추적과 이동 이력을 수집하며, 경량·저전력 설계로 다양한 물류·제조 환경에 유연하게 적용할 수 있는 위치추적 전용 기기입니다.',
    img: stickerTag,
    link: '/rtls/uwb',
  },
  slimTag: {
    title: 'Slim Tag',
    desc: 'Slim Tag는 카드형 초슬림 디자인의 BLE 기반 위치추적 태그로, 유니폼 포켓이나 자산 표면에 쉽게 삽입하거나 부착할 수 있으며, 경량 저전력 설계로 인원 및 자산의 실내 위치를 손쉽게 관리할 수 있습니다.',
    img: slimTag,
    link: '/rtls/uwb',
  },
  edgeRtls: {
    title: 'ORBRO Edge RTLS',
    desc: 'ORBRO Edge RTLS는 현장에서 수신한 태그 신호를 실시간으로 처리해 위치를 계산하고, 클라우드 없이도 독립적으로 운영 가능한 초저지연 위치추적 전용 엣지 디바이스입니다.',
    img: edgeRtls,
    link: '/os/rtls',
  },
  edgeAi: {
    title: 'ORBRO Edge AI',
    desc: 'ORBRO Edge AI는 현장에서 수신한 태그 신호를 실시간으로 처리해 위치를 계산하고, 클라우드 없이도 독립적으로 운영 가능한 초저지연 위치추적 전용 엣지 디바이스입니다.',
    img: edgeRtls,
    link: '/os/rtls',
  },
  switch: {
    title: 'L2 PoE Switch',
    desc: 'L2 PoE Switch는 네트워크 케이블만으로 전력 공급과 데이터 통신을 동시에 처리할 수 있는 장비로, IP 카메라·UWB앵커·BLE 리더 등 다양한 현장 디바이스를 효율적으로 연결하고 중앙 배선 효율을 높여주는 고효율 네트워크 스위치입니다.',
    img: switchImg,
    link: '/os/switch',
  },
  plutoconPro: {
    title: 'Plutocon Pro',
    desc: 'Plutocon Pro는 BLE 기반의 강력한 신호 송출 기능을 갖춘 산업용 비콘으로, 넓은 범위에서도 안정적인 위치 인식이 가능하며, 방수·방진 설계와 배터리 교체형 구조로 물류, 제조, 자산관리 환경에 최적화된 위치 인식 장치입니다.',
    img: plutoconPro,
    link: '/rtls/ble',
  },
  safeTag: {
    title: 'Safe Tag',
    desc: 'Safe Tag는 스마트폰, 태블릿 등 전시용 디바이스에 부착되어 이탈, 분리, 진동 등의 이상 징후를 실시간으로 감지하고 알림을 전송하는 전용 보안 태그입니다.',
    img: safeTag,
    link: '/os/rtls',
  },
  safetyBell: {
    title: 'Safety Bell',
    desc: 'Safety Bell은 긴급 상황 발생 시 즉각적인 알람과 시각‧청각 경고를 제공하는 안전 보조 장치로, 무선으로 시스템에 연동되어 현장 전반의 안전 대응 속도와 효율성을 향상시킵니다.',
    img: safetyBell,
    link: '/os/rtls',
  },
  safeCradle: {
    title: 'Safe Cradle',
    desc: '크래들은 Safe Tag와 전시 기기를 고정시키는 전용 거치대로, 전원 공급과 동시에 무선 통신 및 보안 감지를 안정적으로 지원하는 장치입니다. 탈부착 방지 설계와 정밀한 도킹 각도로 제작되어, 태그 분리·진동·이탈 등 이상 상황 발생 시 즉시 알림을 전송 합니다.',
    img: safeCradle,

    link: '/os/rtls',
  },
  loraGateway: {
    title: 'LoRA Gateway',
    desc: 'LoRa Gateway는 장거리 통신을 지원하는 LoRaWAN 프로토콜 기반 네트워크 허브로, 멀리 떨어진 센서나 태그들로부터 데이터를 안정적으로 수집하여 클라우드 또는 엣지 서버로 전달하는 역할을 합니다.',
    img: loraGateway,
    link: '/os/rtls',
  },
  patientTag: {
    title: 'Patient Tag',
    desc: '환자용 태그는 병원 환경에서 환자에게 안전하게 착용되어 위치를 실시간 추적하고, 지정 구역 이탈이나 응급 상황 발생 시 자동 알림을 통해 신속한 대응을 가능하게 하는 저전력 UWB/BLE 기반 의료용 위치추적 기기입니다.',
    img: patientTag,
    link: '/rtls/ble',
  },
  idCard: {
    title: 'ID Card',
    desc: 'ID카드(사원증)는 직원의 신원을 확인하고 출입 통제를 원활하게 하는 도구로, 내구성 있는 플라스틱 카드에 BLE칩을 탑재하여 비접촉 방식으로 빠르고 안전한 인증을 지원합니다.',
    img: idCard,
    link: '/rtls/ble',
  },
};
